export default __webpack_public_path__ + "337bf49b364a9c99f9dbb07c2d23704e.svg";